import { SvgIcon } from '@material-ui/core'

export function FilterIcon(props) {
  return (
    <SvgIcon {...props} fill="none">
      <path
        d="M6 12H18M3 6H21M9 18H15"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
